module.exports = __webpack_public_path__ + "img/AiLoad.b7d18bec.png";